class LazyLoader {
    constructor(elements, options = {}) {
        this.options = Object.assign(
            {},
            {    
                targetPos: "",
                addpixel: 400,
                maxConcurrentLoads: 3
            }, 
            options
        ); 
        this.elements = elements;
        this.loadingCount = 0;
        this.queue = [];
        
        if (typeof IntersectionObserver != "undefined") {
            this.config = {  
                threshold: 0.1,
                rootMargin: '0px 100px -100px 0px'
            };
            this.observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => { 
                    if (entry.isIntersecting) {
                        if (this.loadingCount < this.options.maxConcurrentLoads) {
                            this.loadElement(entry.target);
                        } else {
                            this.queue.push(entry.target);
                        }
                        this.observer.unobserve(entry.target);
                    }
                });
            }, this.config);  
            this.elements.forEach(element => {
                this.observer.observe(element);
            });
        } else {
            this.elements.forEach(element => {
                this.loadElement(element);
            });
        } 
    }
    
    loadElement(element) {
        this.loadingCount++;
        const isImage = element.tagName === 'IMG';
        
        if (isImage) {
            const image = element;
            let containerWidth = image.closest("div").offsetWidth;
            let containerHeight = image.closest("div").offsetHeight;
            let lcpMob = false;
            if (window.innerWidth < 992 && image.classList.contains("lcp")) {
                lcpMob = true;
            }
            if (!lcpMob) {
                let urls;
                let closest;
                if (image.classList.contains("ext")) {
                    const url = image.getAttribute("data-src");
                    image.src = url;
                    image.classList.add("loaded");
                } else {
                    let sizes = [1800, 1600, 1400, 1200, 1000, 800, 600, 500, 400, 300, 200];
                    if (containerHeight > containerWidth) {
                        containerHeight += this.options.addpixel;
                        closest = sizes.reduce((prev, curr) =>
                            Math.abs(curr - containerHeight) < Math.abs(prev - containerHeight) ? curr : prev
                        );
                        urls = {
                            1800: image.getAttribute("data-src-1800h"),
                            1600: image.getAttribute("data-src-1600h"),
                            1400: image.getAttribute("data-src-1400h"),
                            1200: image.getAttribute("data-src-1200h"),
                            1000: image.getAttribute("data-src-1000h"),
                            800: image.getAttribute("data-src-800h"),
                            600: image.getAttribute("data-src-600h"),
                            500: image.getAttribute("data-src-500h"),
                            400: image.getAttribute("data-src-400h"),
                            300: image.getAttribute("data-src-300h"),
                            200: image.getAttribute("data-src-200h")
                        };
                    } else {
                        containerWidth += this.options.addpixel;
                        closest = sizes.reduce((prev, curr) =>
                            Math.abs(curr - containerWidth) < Math.abs(prev - containerWidth) ? curr : prev
                        );
                        urls = {
                            1800: image.getAttribute("data-src-1800w"),
                            1600: image.getAttribute("data-src-1600w"),
                            1400: image.getAttribute("data-src-1400w"),
                            1200: image.getAttribute("data-src-1200w"),
                            1000: image.getAttribute("data-src-1000w"),
                            800: image.getAttribute("data-src-800w"),
                            600: image.getAttribute("data-src-600w"),
                            500: image.getAttribute("data-src-500w"),
                            400: image.getAttribute("data-src-400w"),
                            300: image.getAttribute("data-src-300w"),
                            200: image.getAttribute("data-src-200w")
                        };
                    }
                    image.src = urls[closest];
                    image.addEventListener('load', () => {
                        image.classList.add('loaded');
                        this.loadingCount--;
                        this.checkQueue();
                    });
                    image.addEventListener('error', () => {
                        console.error(`Failed to load image: ${image.src}`);
                        this.loadingCount--;
                        this.checkQueue();
                    });
                }
            }
        } else {
            const video = element;
            for (let source of video.children) {
                if (source.tagName === "SOURCE") {
                    source.src = source.dataset.src;
                }
            }
            video.addEventListener('canplaythrough', () => {
                video.classList.add("loaded");
                video.play();
                this.loadingCount--;
                this.checkQueue();
            }, { once: true });
            video.load();
        }
    }

    checkQueue() {
        if (this.queue.length > 0 && this.loadingCount < this.options.maxConcurrentLoads) {
            const nextElement = this.queue.shift();
            this.loadElement(nextElement);
        }
    }
}

var lazyImg = new LazyLoader(document.querySelectorAll("img.lazy"));
var lazyVideo = new LazyLoader(document.querySelectorAll("video.lazy"));